import { ConfirmEnrollmentInput } from '../../lib/types/models/enrollment/enrollment-input'
import { IdInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function confirmEnrollment({ id, ...data }: IdInput<ConfirmEnrollmentInput>) {
  return restApiClient
    .url(constructApiUrl(API.enrollments.confirmEnrollment.url, { id }))
    .post<unknown, ConfirmEnrollmentInput>(data)
}
